<template>
  <div>
    <mtd-row class="page-title-block" style="margin-bottom: 0">
      <mtd-row style="display: flex; align-items: center;">
        <mtd-col :span="12">
          <mtd-icon-button class="demo-icon-btn" type="secondary" icon="mtdicon mtdicon-arrow-left"
                           @click="back_alarms"/>
          <span class="page-head-title" style="margin-left: 12px;">
            {{ $getText('operation_alarm_title_reminder', '告警工单') }}
          </span>
          <mtd-tag theme="green" type="pure" class="page-head-title-tag"
                   v-if="alarm_info.taskStatus !== 100 && alarm_info.rowStatus === 1">
            {{ $getText('operation_alarm_status_only_reminder', '仅告警提醒') }}
          </mtd-tag>
          <mtd-tag theme="red" type="pure" class="page-head-title-tag"
                   v-if="alarm_info.taskStatus !== 100 && alarm_info.rowStatus === 2 && alarm_info.beAlertedMis === alarm_info.recipient">
            {{ $getText('operation_alarm_status_self_feedback', '待本人反馈') }}
          </mtd-tag>
          <mtd-tag theme="red" type="pure" class="page-head-title-tag"
                   v-else-if="alarm_info.taskStatus !== 100 && alarm_info.rowStatus === 2 && (alarm_info.supervisor === alarm_info.recipient || (alarm_info.noticeConfig && alarm_info.noticeConfig.noticeObject === 3))">
            {{ $getText('operation_platform_status_supervisor_feedback', '待相关方反馈') }}
          </mtd-tag>
          <mtd-tag theme="red" type="pure" class="page-head-title-tag"
                   v-else-if="alarm_info.taskStatus !== 100 && alarm_info.rowStatus === 2">
            {{ $getText('operation_platform_status_cc_feedback', '待抄送人反馈') }}
          </mtd-tag>
          <mtd-tag theme="red" type="pure" class="page-head-title-tag"
                   v-if="alarm_info.taskStatus !== 100 && alarm_info.rowStatus === 3">
            {{ $getText('operation_alarm_status_supersivor_confirm', '待相关方确认') }}
          </mtd-tag>
          <mtd-tag theme="red" type="pure" class="page-head-title-tag"
                   v-if="alarm_info.taskStatus !== 100 && alarm_info.rowStatus === 6">
            {{ $getText('operation_alarm_status_sec_recheck', '待信安复核') }}
          </mtd-tag>
          <mtd-tag theme="green" type="pure" class="page-head-title-tag"
                   v-if="alarm_info.taskStatus !== 100 && alarm_info.rowStatus === 9">
            {{ $getText('operation_alarm_status_finished', '已完成') }}
          </mtd-tag>
          <mtd-tag theme="green" type="pure" class="page-head-title-tag" v-if="alarm_info.taskStatus === 100">
            {{ $getText('operation_alarm_status_finished', '已完成') }}
          </mtd-tag>
        </mtd-col>
        <mtd-col :span="12">
          <div style="float: right">
            <mtd-button style="margin-right: 10px" v-if="show_task_button()" icon="mtdicon-schedule" class="btn-demo-item" type="primary" @click="open_task_detail">
<!--              查看任务详情-->
              {{ $getText('operation_alarm_btn_view_task', '查看任务详情') }}
            </mtd-button>
            <mtd-button style="margin-right: 10px" type="primary" icon="mtdicon-avatar-add" ghost @click="open_cc_modal">
              {{ $getText('operation_alarm_btn_add_cc', '添加抄送人') }}
            </mtd-button>
            <mtd-button style="margin-right: 10px" icon="mtdicon-link-o" class="btn-demo-item" ghost type="primary"
                        v-clipboard:copy="urge_url"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError">
              {{ $getText('operation_alarm_btn_copy_link', '复制催办链接') }}
            </mtd-button>
            <mtd-button href="https://km.sankuai.com/collabpage/2257670643" icon="mtdicon-question-circle-o" target="_blank" type="primary" ghost>
              {{ $getText('operation_alarm_btn_view_faq', '查看FAQ文档')}}
            </mtd-button>
          </div>
        </mtd-col>
      </mtd-row>
    </mtd-row>
    <mtd-row :gutter="16">
      <mtd-col :span="18" style="padding-left: 0">
        <div class="page-content-block">
          <mtd-row>
            <span class="page-second-title">{{ $getText('operation_alarm_title_detail', '告警详情') }}</span>
          </mtd-row>
          <mtd-row v-if="risk_summary.length !== 0" class="height-56 line-height-56">
            <mtd-col :span="24" class="height-full">
              <span class="page-second-title">风险概览</span>
            </mtd-col>
          </mtd-row>
          <mtd-row v-if="risk_summary.length !== 0">
            <mtd-col :span="24" class="height-full">
              <span v-html="alarm_info.content"></span>
            </mtd-col>
          </mtd-row>
          <div v-if="risk_summary.length === 0">
            <mtd-row class="info-row">
              <mtd-col class="info-col" :span="12">
                <span class="info-title">
                  {{ alarm_info.targetType === 2 ? $getText('operation_alarm_column_mis', '责任人')  + "："
                  : $getText('operation_alarm_column_mis', '当事人账号') + "：" }}
                </span>
                <div class="info-content">
                  {{ alarm_info.beAlertedMis }}
                </div>
              </mtd-col>
              <mtd-col class="info-col" :span="12">
                <span class="info-title">{{ $getText('operation_alarm_name', '告警名称') }}：</span>
                <div class="info-content">
                  {{ alarm_info.alarmName || alarm_info.taskName }}
                </div>
              </mtd-col>
            </mtd-row>
            <mtd-row class="info-row">
              <mtd-col class="info-col" :span="12">
                <span class="info-title">{{ $getText('operation_alarm_time', '告警时间') }}：</span>
                <div class="info-content">
                  {{ alarm_info.createTime|dateTimeFormat }}
                </div>
              </mtd-col>
              <mtd-col class="info-col" :span="12">
                <span class="info-title">{{ $getText('operation_alarm_cc', '抄送人') }}：</span>
                <div class="info-content">
                  <mtd-tooltip :content="alarm_info.cc" placement="top-start">
                    <span>{{ alarm_info.cc }}</span>
                  </mtd-tooltip>
                </div>
              </mtd-col>
            </mtd-row>
            <mtd-row class="info-row">
              <mtd-col :span="24">
                <span class="info-title">{{ $getText('operation_alarm_risk_detail', '风险详情') }}：</span>
                <div class="info-full-content" ref="contentWrapper">
                  <div :style="!showFullContent ? { 'max-height': maxHeight + 'px', overflow: 'hidden' } : {}">
                    <template v-if="alarm_info.beAlertedMis === this.login_user.mis_id">
                      <div v-html="is_en ? (alarm_info.enContent || alarm_info.content) : alarm_info.content"></div>
                    </template>
                    <template v-else-if="alarm_info.supervisor === this.login_user.mis_id">
                      <div v-html="is_en ? (alarm_info.enSuperiorContent || alarm_info.superiorContent || alarm_info.enContent || alarm_info.content) : (alarm_info.superiorContent || alarm_info.content)"></div>
                    </template>
                    <template v-else-if="is_cc_role">
                      <div v-html="is_en ? (alarm_info.enCcContent || alarm_info.ccContent || alarm_info.enContent || alarm_info.content) : (alarm_info.ccContent || alarm_info.content)"></div>
                    </template>
                    <template v-else>
                      <div v-html="is_en ? (alarm_info.enContent || alarm_info.content) : alarm_info.content"></div>
                    </template>
                  </div>
                </div>
              </mtd-col>
            </mtd-row>
          </div>
          <div v-if="risk_summary.length !== 0">
            <mtd-row class="height-56 line-height-56">
              <mtd-col :span="24" class="height-full">
                <span class="page-second-title">{{ $getText('operation_alarm_risk_detail', '风险详情') }}：</span>
                <mtd-button style="float: right;margin-top: 10px" class="btn-demo-item" type="primary"
                            icon="mtdicon mtdicon-export-o" @click="export_to_excel()">导出为Excel
                </mtd-button>
              </mtd-col>
            </mtd-row>
            <mtd-row>
              <mtd-col class="height-full">
                <mtd-table :data="risk_summary" size="small" :height="risk_height" bordered>
                  <mtd-table-column v-for="(item,key) in risk_summary_mapping" :key="key" :prop="key" :label="item"
                                    resizable/>
                </mtd-table>
              </mtd-col>
            </mtd-row>
            <mtd-row class="height-56 line-height-56">
              <mtd-col :span="24" class="height-full">
                <span class="page-second-title">明细日志</span>
              </mtd-col>
            </mtd-row>
            <mtd-row>
              <mtd-col class="height-full">
                <mtd-table :data="risk_details_show" size="small" bordered>
                  <mtd-table-column v-for="(item,key) in risk_details_mapping" :key="key" :prop="key" :label="item"
                                    resizable show-overflow-tooltip/>
                </mtd-table>
                <mtd-pagination
                  show-size-changer
                  :total="risk_details.length"
                  :show-total="true"
                  :current-page.sync="currentPage"
                  :page-size.sync="limit"
                  size="small"
                  @change="change_risk_details"
                  style="float: right;margin-top: 13px"/>
              </mtd-col>
            </mtd-row>
          </div>
          <div>
            <mtd-row class="info-row">
              <mtd-col class="info-col" :span="24">
                <span class="info-title">&nbsp;</span>
                <a href="javascript:void(0)"
                   v-if="isContentOverflow"
                   @click="toggleContent"
                   :style="{ color: '#007BFF'}">
                  <span>{{ showFullContent ? $getText('operation_alarm_btn_collapse', '点击收起') : $getText('operation_alarm_btn_view_all', '点击查看全部内容') }}</span>
                  <template v-if="showFullContent">
                    <i class="mtdicon mtdicon-up"></i>
                  </template>
                  <template v-else>
                    <i class="mtdicon mtdicon-down"></i>
                  </template>
                </a>
              </mtd-col>
            </mtd-row>
          </div>
        </div>
        <div class="page-content-block" v-if="appeal_show || appeal_result_show">
          <!-- 用户反馈表单 -->
          <mtd-row v-if="appeal_show && !appeal_result_show && !file_out_show">
            <mtd-row>
              <span class="page-second-title">{{ $getText('operation_alarm_title_feedback', '反馈') }}</span>
            </mtd-row>
            <div style="margin-top: 5px;">
              <mtd-form :label-width="80">
                <mtd-form-item :label="text_data.reason" class="small-mtd-form-item">
                  <mtd-radio-group v-model="appeal_type">
                    <mtd-radio :value="item" v-for="(item, index) in radioList" v-bind:key="index">{{ item }}</mtd-radio>
                  </mtd-radio-group>
                </mtd-form-item>
                <mtd-form-item label="" class="small-mtd-form-item">
                  <mtd-textarea :placeholder="text_data.feedback_tips" v-model="appeal_other_reason" style="width: 100%;"
                                rows="3" maxlength="500" :invalid="appeal_other_reason === ''"/>
                </mtd-form-item>
                <mtd-form-item style="margin-top: 12px">
                  <mtd-button type="primary" style="margin-right: 12px;" @click="submit_appeal_reason"
                              :disabled="appeal_type === '' || appeal_other_reason === ''">
                    {{ $getText('operation_alarm_btn_confirm', '确定') }}
                  </mtd-button>
                  <mtd-button @click="appeal_show = false" v-if="alarm_info.rowStatus === 1">{{ $getText('operation_alarm_btn_cancel', '取消') }}</mtd-button>
                  <mtd-button @click="editCancel" v-if="editAppealFlag">{{ $getText('operation_alarm_btn_cancel', '取消') }}
                  </mtd-button>
                </mtd-form-item>
              </mtd-form>
            </div>
          </mtd-row>
          <!-- 外发质询用户反馈表单 -->
          <mtd-row v-if="appeal_show && !appeal_result_show && file_out_show">
            <mtd-col :span="24" class="height-full">
              <div>
                <div>
                  <span class="page-second-title">{{ $getText('operation_alarm_title_feedback', '反馈') }}</span>
                </div>
                <div style="margin-top: 5px;">
                  <mtd-form :label-width="120">
                    <mtd-form-item :label="text_data.reason" class="small-mtd-form-item" :helper="getDescription(appeal_type, 0)">
                      <mtd-radio-group v-model="appeal_type">
                        <mtd-radio :value="item" v-for="(item, index) in radioList" :key="index">{{ item }}</mtd-radio>
                      </mtd-radio-group>
                    </mtd-form-item>
                    <mtd-form-item :label="text_data.send_object + ':'" class="small-mtd-form-item mtd-form-item-required">
                      <mtd-input v-model="sendObject" style="width: 100%"
                                 :placeholder="text_data.send_object_tips"/>
                    </mtd-form-item>
                    <mtd-form-item :label="text_data.feedback_proof + ':'" class="small-mtd-form-item"
                                   :helper="text_data.feedback_proof_tips">
                      <div>
                        <mtd-upload
                          class="picture-list"
                          action="/api/task/uploadImg"
                          list-type="picture-card"
                          accept="image/*"
                          :on-success="uploadToVenus"
                          :before-remove="removePicture"
                          :on-preview="handlePictureCardPreview"
                          :file-list="files">
                          <i class="mtdicon-add"/>
                        </mtd-upload>
                        <mtd-modal v-model="previewVisible">
                          <img :src="previewImageUrl"/>
                        </mtd-modal>
                      </div>
                    </mtd-form-item>
                    <mtd-form-item :label="text_data.description" class="small-mtd-form-item" required>
                      <mtd-textarea :placeholder="text_data.feedback_tips" v-model="appeal_other_reason"
                                    style="width: 100%;"
                                    rows="3" maxlength="500"/>
                    </mtd-form-item>
                    <mtd-form-item style="margin-top: 12px">
                      <mtd-button type="primary" style="margin-right: 12px;" @click="submit_file_out"
                                  :disabled="file_out_disabled">
                        {{ $getText('operation_alarm_btn_confirm', '确定') }}
                      </mtd-button>
                      <mtd-button @click="appeal_show = false" v-if="alarm_info.rowStatus === 1">{{ $getText('operation_alarm_btn_cancel', '取消') }}</mtd-button>
                      <mtd-button @click="editCancel" v-if="editAppealFlag">{{ $getText('operation_alarm_btn_cancel', '取消') }}
                      </mtd-button>
                    </mtd-form-item>
                  </mtd-form>
                </div>
              </div>
            </mtd-col>
          </mtd-row>
          <!-- 用户反馈结果展示 -->
          <mtd-row v-if="appeal_result_show && !file_out_show">
            <mtd-row>
              <span class="page-second-title">{{ self_appeal_text }}</span>
              <mtd-tag theme="red" type="pure" class="page-head-title-tag" v-if="alarm_info.visitFlag === 0">
                {{ $getText('operation_alarm_feedback_no_view', '未查看') }}
              </mtd-tag>
              <mtd-tag theme="green" type="pure" class="page-head-title-tag" v-if="alarm_info.visitFlag === 1">
                {{ $getText('operation_alarm_feedback_viewed', '已查看') }}
              </mtd-tag>
              <mtd-icon-button v-if="appeal_edit_show" class="demo-icon-btn" icon="mtdicon mtdicon-edit-o"
                               @click="editAppeal"/>
            </mtd-row>
            <mtd-row class="info-row">
              <mtd-col :span="24">
                <span class="info-title">{{ $getText('operation_alarm_self_feedback_reason', '原因') }}：</span>
                <div class="info-full-content">
                  {{ alarm_info.appealType | appealTypeFilter(this.radioList) }}: {{ alarm_info.appealReason }}
                </div>
              </mtd-col>
            </mtd-row>
          </mtd-row>
          <mtd-row v-if="appeal_result_show && file_out_show">
            <mtd-row>
              <span class="page-second-title">{{ self_appeal_text }}</span>
              <mtd-tag theme="red" type="pure" class="page-head-title-tag" v-if="alarm_info.visitFlag === 0">
                {{ $getText('operation_alarm_feedback_no_view', '未查看') }}
              </mtd-tag>
              <mtd-tag theme="green" type="pure" class="page-head-title-tag" v-if="alarm_info.visitFlag === 1">
                {{ $getText('operation_alarm_feedback_viewed', '已查看') }}
              </mtd-tag>
              <mtd-icon-button v-if="appeal_edit_show" class="demo-icon-btn" icon="mtdicon mtdicon-edit-o"
                               @click="editAppeal"/>
            </mtd-row>
            <mtd-row class="info-row">
              <mtd-col :span="24">
                <span class="info-title" style="width: 165px">{{ $getText('operation_alarm_self_feedback_reason', '原因') }}：</span>
                <div class="info-full-content">
                  {{ alarm_info.appealType | appealTypeFilter(this.radioList) }}: {{ alarm_info.appealReason }}
                </div>
              </mtd-col>
            </mtd-row>
            <mtd-row class="info-row">
              <mtd-col class="info-col" :span="24">
                <span class="info-title" style="width: 165px">{{ $getText('operation_alarm_feedback_send_object', '发送对象') }}：</span>
                <div class="info-content">
                  {{ alarm_info.sendObject }}
                </div>
              </mtd-col>
            </mtd-row>
            <mtd-row class="info-row">
              <mtd-col :span="24">
                <span class="info-title" style="width: 165px">{{ $getText('operation_alarm_feedback_proof', '发送记录证明') }}：</span>
                <div class="info-full-content">
                  <div>
                    <img :src="item"
                         v-for="(item, index) in (!alarm_info.pictures ? [] : alarm_info.pictures.split(','))"
                         v-bind:key="index" style="width: 160px;height: 160px;cursor: pointer"
                         @click="picturePreview(item)"/>
                  </div>
                  <mtd-modal v-model="resultPreviewModal">
                    <img :src="activeImg"/>
                  </mtd-modal>
                </div>
              </mtd-col>
            </mtd-row>
          </mtd-row>
        </div>
        <div class="page-content-block" v-if="feedback_show || feedback_result_show">
          <!-- 领导确认表单 -->
          <mtd-row v-if="feedback_show && !feedback_result_show">
            <div>
              <span class="page-second-title">{{ $getText('operation_alarm_supervisor_confirm', '相关方确认') }}</span>
              <span class="submit-helper">{{ $getText('operation_alarm_supervisor_tips', '请根据实际情况核实，如有隐瞒将根据阳光职场追究不诚信责任') }}</span>
            </div>
            <div style="margin-top: 5px;">
              <mtd-form :label-width="80">
                <mtd-form-item :label="text_data.supervisor_confirm + ':'" class="small-mtd-form-item" :helper="getDescription(feedback_reason, 1)">
                  <mtd-radio-group v-model="feedback_reason">
                    <mtd-radio :value="item" v-for="(item, index) in superiorRadioList" :key="index">{{
                        item
                      }}
                    </mtd-radio>
                  </mtd-radio-group>
                </mtd-form-item>
                <mtd-form-item :label="text_data.description" class="small-mtd-form-item">
                  <mtd-textarea :placeholder="text_data.description" v-model="feedback_other_reason" style="width: 100%;"
                                rows="3" maxlength="500">
                  </mtd-textarea>
                </mtd-form-item>
                <mtd-form-item>
                  <mtd-button type="primary" style="margin-right: 12px;" @click="submit_feedback_reason"
                              :disabled="feedback_other_reason === '' || feedback_reason === ''">
                    {{ $getText('operation_alarm_btn_confirm', '确定') }}
                  </mtd-button>
                  <mtd-button @click="editFeedbackCancel" v-if="editFeedbackFlag">{{ $getText('operation_alarm_btn_cancel', '取消') }}</mtd-button>
                </mtd-form-item>
              </mtd-form>
            </div>
          </mtd-row>
          <!-- 领导确认结果 -->
          <mtd-row v-if="feedback_result_show">
            <mtd-row>
              <span class="page-second-title">{{ $getText('operation_alarm_supervisor_confirm', '上级确认') }}</span>
              <mtd-icon-button v-if="feedback_edit_show" class="demo-icon-btn" icon="mtdicon mtdicon-edit-o"
                               @click="editFeedback"/>
            </mtd-row>
            <mtd-row class="info-row">
              <mtd-col :span="24">
                <span class="info-title">{{ $getText('operation_alarm_feedback_confirm', '确认') }}：</span>
                <div class="info-full-content">
                  {{ alarm_info.feedbackReason }}
                </div>
              </mtd-col>
            </mtd-row>
          </mtd-row>
        </div>
      </mtd-col>
      <mtd-col :span="6" style="padding-right: 0">
        <div class="page-content-block">
          <mtd-row class="height-full" style="margin-bottom: 10px">
            <span class="page-second-title">{{ $getText('operation_alarm_process', '工单处理进度') }}</span>
            <mtd-tag v-if="!reminder_log.deleteForbidden" theme="red" type="pure" class="page-head-title-tag">
              {{ $getText('operation_alarm_system_forbidden', '已封禁系统权限') }}
            </mtd-tag>
          </mtd-row>
          <mtd-row>
            <mtd-steps class="mtd-steps-custom" direction="vertical" :active="step" space="auto" size="small">
              <mtd-step v-if="reminder_log.alarm !== null && reminder_log.alarm !== undefined">
                <template slot="title">
                  <span>{{ $getText('operation_alarm_process_send_notice', '发送大象通知') }}</span>
                  <span class="step-time-text">{{ reminder_log.alarm|dateTimeFormat }}</span>
                </template>
                <template slot="description">
                  <span>{{ $getText('operation_alarm_recipient', '接收人') }}：{{ alarm_info.recipient }}</span>
                  <span v-if="alarm_info.cc"><br/>{{ $getText('operation_alarm_cc', '抄送人') }}：{{ alarm_info.cc }}</span>
                </template>
              </mtd-step>
              <mtd-step v-if="reminder_log.feedback !== null && reminder_log.feedback !== undefined">
                <template slot="title">
                  <span v-if="alarm_info.rowStatus === 2" class="step-processing-text">
                    {{ $getText('operation_alarm_label_processing', '正在进行') }}
                  </span>
                  <span>{{ self_appeal_text }}</span>
                  <mtd-tag theme="red" style="vertical-align: text-top" class="page-head-title-tag" size="small"
                           v-if="alarm_info.rowStatus === 2">
                    {{ $getText('operation_alarm_status_self_feedback', '待反馈') }}
                  </mtd-tag>
                  <mtd-tag theme="green" style="vertical-align: text-top" class="page-head-title-tag" size="small"
                           v-if="reminder_log.feedback">
                    {{ $getText('operation_alarm_feedback', '已反馈') }}
                  </mtd-tag>
                  <span class="step-time-text">{{ reminder_log.feedback|dateTimeFormat }}</span>
                </template>
                <template slot="description">
                  <span style="font-size:14px;color: #222222">{{ $getText('operation_alarm_handler', '处理人') }}：{{ alarm_info.recipient }}</span><br/>
                  <span style="padding: 10px 0" v-if="alarm_info.appealReason">
                    {{ alarm_info.appealType | appealTypeFilter(this.radioList) }}: {{ alarm_info.appealReason }}
                  </span>
                  <span v-if="alarm_info.rowStatus === 2" style="color: #0a70f5">
                    {{ $getText('operation_alarm_on_processing', '进行中') }}...
                  </span>
                </template>
              </mtd-step>
              <mtd-step v-if="reminder_log.confirm !== null && reminder_log.confirm !== undefined" >
                <template slot="title">
                  <span v-if="alarm_info.rowStatus === 3" class="step-processing-text">
                    {{ $getText('operation_alarm_label_processing', '正在进行') }}
                  </span>
                  <span>{{ $getText('operation_alarm_process_supervisor_confirm', '相关方确认') }}</span>
                  <mtd-tag theme="red" class="page-head-title-tag" size="small"
                           v-if="alarm_info.rowStatus === 3">
                    {{ $getText('operation_alarm_status_supersivor_confirm', '待相关方确认') }}
                  </mtd-tag>
                  <mtd-tag theme="green" class="page-head-title-tag" size="small"
                           v-if="reminder_log.confirm">
                    {{ $getText('operation_alarm_feedback', '已反馈') }}
                  </mtd-tag>
                  <span class="step-time-text">{{ reminder_log.confirm|dateTimeFormat }}</span>
                </template>
                <template slot="description">
                  <span style="font-size:14px;color: #222222">
                    {{ $getText('operation_alarm_handler', '处理人') }}
                    <mtd-tooltip :content="$getText('operation_alarm_process_supervisor_confirm_tips')" placement="top">
                      <i class='mtdicon mtdicon-question-circle-o'/>
                    </mtd-tooltip>
                    ：{{ alarm_info.supervisor }}
                    <mtd-button v-if="isRdOrPm() && (alarm_info.rowStatus === 3 || alarm_info.rowStatus === 2)" type="text" icon="mtdicon mtdicon-edit-o" @click="open_change_supervisor_modal()">变更</mtd-button>
                  </span><br/>
                  <span style="padding: 10px 0" v-if="alarm_info.feedbackReason && this.login_user.mis_id !== alarm_info.beAlertedMis">{{ alarm_info.feedbackReason }}</span>
                  <span v-if="alarm_info.rowStatus === 3" style="color: #0a70f5">{{ $getText('operation_alarm_on_processing', '进行中') }}...</span>
                </template>
              </mtd-step>
              <mtd-step v-if="reminder_log.check !== null && reminder_log.check !== undefined">
                <template slot="title">
                  <span v-if="alarm_info.rowStatus === 6" class="step-processing-text">
                    {{ $getText('operation_alarm_label_processing', '正在进行') }}
                  </span>
                  <span>{{ $getText('operation_alarm_process_sec_recheck', '信安复核') }}</span>
                  <span class="step-time-text">{{ reminder_log.check|dateTimeFormat }}</span>
                </template>
                <template slot="description">
                  <span v-if="alarm_info.rowStatus === 6">
                    <span style="font-size:14px;color: #222222">{{ $getText('operation_alarm_handler', '处理人') }}：{{ alarm_info.principal }}</span><br/>
                  </span>
                  <span style="padding: 10px 0" v-if="reminder_log.check">{{ $getText('operation_alarm_process_sec_checked','信安已复核，工单将关闭') }}</span>
                  <span v-if="alarm_info.rowStatus === 6" style="color: #0a70f5">{{ $getText('operation_alarm_on_processing', '进行中') }}...</span>
                </template>
              </mtd-step>
              <mtd-step v-if="reminder_log.finish !== null && reminder_log.finish !== undefined">
                <template slot="title">
                  <span>{{ $getText('operation_alarm_process_finish', '完成') }}</span>
                  <span class="step-time-text">{{ reminder_log.finish|dateTimeFormat }}</span>
                </template>
              </mtd-step>
              <mtd-step v-if="reminder_log.close !== null && reminder_log.close !== undefined">
                <template slot="title">
                  <span>{{ $getText('operation_alarm_sec_closed', '信安关闭告警') }}</span>
                  <span class="step-time-text">{{ reminder_log.close|dateTimeFormat }}</span>
                </template>
              </mtd-step>
            </mtd-steps>
          </mtd-row>
        </div>
      </mtd-col>
    </mtd-row>
    <mtd-modal :title="text_data.add_cc_title" width="40%" v-model="cc_modal"
               @close="close_cc_modal">
      <mtd-row>
        <mtd-form ref="cc_form_ref" :label-width="120" :model="cc_form">
          <mtd-form-item :label="text_data.cc_list" prop="ccList" :rules="{required: true, message: text_data.input_mis_tips}">
            <mtd-select :filterable="true" style="width: 100%" v-model="cc_form.ccList"
                        multiple :remote="true" :remote-method="query_misid_list"
                        :loading="misid_loading" :placeholder="text_data.input_mis_tips">
              <mtd-option v-for="item in user_misid_list" :key="item.mis" :label="item.name + '/' + item.mis"
                          :value="item.mis"/>
            </mtd-select>
          </mtd-form-item>
        </mtd-form>
      </mtd-row>
      <div slot="footer" class="demo-modal-footer">
        <mtd-button @click="close_cc_modal">{{ $getText('operation_alarm_btn_cancel', '取消') }}</mtd-button>
        <mtd-button type="primary" @click="submit_cc_form()">{{ $getText('operation_alarm_btn_confirm', '确定') }}</mtd-button>
      </div>
    </mtd-modal>
    <mtd-modal title="变更确认人" width="40%" v-model="change_supervisor_modal"
               @close="close_change_supervisor_modal">
      <mtd-row>
        <mtd-form ref="change_supervisor_form_ref" :label-width="90" :model="change_supervisor_form">
          <mtd-form-item label="变更为:" prop="supervisor" :rules="{required: true, message: text_data.input_mis_tips}">
            <mtd-select :filterable="true" style="width: 100%" v-model="change_supervisor_form.supervisor"
                        :remote="true" :remote-method="query_misid_list" clearable
                        :loading="misid_loading" :placeholder="text_data.input_mis_tips">
              <mtd-option v-for="item in user_misid_list" :key="item.mis" :label="item.name + '/' + item.mis"
                          :value="item.mis"/>
            </mtd-select>
          </mtd-form-item>
          <mtd-form-item label="变更原因:" prop="reason" :rules="{required: true, message: '请输入变更原因'}"
                         helper="提示：本功能仅运营可见，变更确认人后仅对当前工单生效">
            <mtd-textarea rows="3" style="width: 100%" placeholder="请输入变更原因" v-model="change_supervisor_form.reason" />
          </mtd-form-item>
        </mtd-form>
      </mtd-row>
      <div slot="footer" class="demo-modal-footer">
        <mtd-button @click="close_change_supervisor_modal">{{ $getText('operation_alarm_btn_cancel', '取消') }}</mtd-button>
        <mtd-button type="primary" @click="submit_change_supervisor_form()">{{ $getText('operation_alarm_btn_confirm', '确定') }}</mtd-button>
      </div>
    </mtd-modal>
  </div>
</template>

<script>

import moment from 'moment';
import {mapActions} from 'vuex'
import XLSX from 'xlsx'
import sso from "utils/sso";

export default {
  name: "detail",
  filters: {
    dateTimeFormat(dateTime) {
      if (dateTime) {
        return moment(dateTime).format('YYYY-MM-DD HH:mm:ss');
      } else {
        return "";
      }
    },
    appealTypeFilter(appealType, array) {
      if (!appealType || appealType === '0') {
        return '暂未反馈';
      } else {
        return array.find(item => item === appealType);
      }
    },
  },
  computed: {
    login_user() {
      return this.$store.getters.get_login_user;
    },
    file_out_disabled() {
      return this.appeal_type === '' || this.appeal_other_reason === '' || this.sendObject === '';
    },
    role_list() {
      return this.$store.getters.get_role_list;
    },
    is_en() {
      return this.$i18nClient.getCurrentLocale() === 'en';
    }
  },
  data() {
    return {
      alarm_id: this.$route.params.id,
      alarm_info: {},
      // 用户反馈
      appeal_show: false,
      appeal_type: '',
      appeal_other_reason: '',
      // 外发质询用户反馈表单
      file_out_show: false,
      sendObject: '',
      files: [],
      pictureUrl: [],
      previewVisible: false,
      previewImageUrl: '',
      // 用户反馈展示
      appeal_user: '',
      appeal_result_show: false,
      appeal_edit_show: false,
      // 领导确认
      feedback_show: false,
      feedback_reason: '',
      feedback_other_reason: '',
      // 领导确认展示
      feedback_result_show: false,
      feedback_edit_show: false,
      // 风险概览表格映射和数据
      risk_summary_mapping: {},
      risk_summary: [],
      // 风险详情表格映射和数据
      risk_details_mapping: {},
      risk_details: [],
      risk_details_show: [],
      currentPage: 1,
      limit: 10,
      risk_height: '',
      editAppealFlag: false,
      editFeedbackFlag: false,
      selection: [],
      detailReason: '',
      activeImg: '',
      resultPreviewModal: false,
      radioList: ['工作需要', '不是本人操作', '不清楚原因', '其他'],
      superiorRadioList: ['情况属实', '存在异常', '其他'],
      // 催办链接
      urge_url: window.location.href,
      is_cc_role: false,
      reminder_log: {},
      step: 0,
      self_appeal_text: '本人反馈',
      descriptionList: [],
      supervisorDescriptionList: [],
      showFullContent: false,
      isContentOverflow: false,
      maxHeight: 10000,
      cc_modal: false,
      cc_form: {
        ccList: []
      },
      user_misid_list: [],
      misid_loading: false,
      change_supervisor_modal: false,
      change_supervisor_form: {
        supervisor: '',
        reason: ''
      },
      text_data: {
        reason: '原因',
        description: '说明',
        add_cc_title: '添加抄送人',
        cc_list: '抄送人',
        feedback_tips: '请输入反馈信息',
        send_object: '发给了谁',
        send_object_tips: '如：同事mis、合作伙伴公司和名称等，没有可以填无',
        feedback_proof: '发送记录证明',
        feedback_proof_tips: '说明：包含文件、发送时间和接收者账号的相关截图',
        supervisor_confirm: '确认',
        input_mis_tips: '请输入MIS',
      }
    }
  },
  mounted: function () {
    this.text_data.reason = this.$getText('operation_alarm_self_feedback_reason', '原因');
    this.text_data.description = this.$getText('operation_alarm_feedback_description', '说明');
    this.text_data.add_cc_title = this.$getText('operation_alarm_btn_add_cc', '添加抄送人');
    this.text_data.cc_list = this.$getText('operation_alarm_cc', '抄送人');
    this.text_data.feedback_tips = this.$getText('operation_alarm_feedback_tips', '请输入反馈信息');
    this.text_data.send_object = this.$getText('operation_alarm_feedback_send_object', '发给了谁');
    this.text_data.send_object_tips = this.$getText('operation_alarm_feedback_send_object_tips', '如：同事mis、合作伙伴公司和名称等，没有可以填无');
    this.text_data.feedback_proof = this.$getText('operation_alarm_feedback_proof', '发送记录证明');
    this.text_data.feedback_proof_tips = this.$getText('operation_alarm_feedback_proof_tips', '说明：包含文件、发送时间和接收者账号的相关截图');
    this.text_data.supervisor_confirm = this.$getText('operation_alarm_feedback_confirm', '确认');
    this.text_data.input_mis_tips = this.$getText('operation_alarm_input_mis_tips', '请输入MIS');

    this.init_data();
  },
  methods: {
    ...mapActions([
      'api_query_reminders_inquiries_by_id',
      'api_update_reminders_inquiries',
      'api_query_reminders_log',
      'api_add_reminders_cc',
      'api_query_org_misid_list',
      'api_change_supervisor',
      'api_check_task_vp'
    ]),
    toggleContent() {
      this.showFullContent = !this.showFullContent;
    },
    checkContentOverflow() {
      const lineHeight = parseInt(getComputedStyle(this.$refs.contentWrapper).lineHeight, 10);
      const contentHeight = this.$refs.contentWrapper.scrollHeight;
      this.maxHeight = lineHeight * 20;
      if (contentHeight >= this.maxHeight) {
        this.isContentOverflow = true;
        this.showFullContent = false;
      }
    },
    change_risk_details(current, size) {
      this.currentPage = current;
      this.limit = size;
      let temp = this.risk_details;
      let start = (this.currentPage - 1) * this.limit;
      let end = this.currentPage * this.limit;
      this.risk_details_show = temp.slice(start, end);
    },
    async init_data() {
      let response = await this.api_query_reminders_inquiries_by_id({id: this.alarm_id});
      this.alarm_info = response.data;

      this.api_query_reminders_log({reminderId: this.alarm_id}).then(res => {
        if (res.code === 0) {
          this.reminder_log = res.data;
          this.step = this.reminder_log.step;
        }
      });

      const isRdOrPm = this.show_task_button();

      let taskName = this.alarm_info.alarmName;
      if (!taskName) {
        taskName = this.alarm_info.taskName;
      }
      document.title = '【' + this.$getText('operation_alarm_title_alarm', '安全告警') + '】' + this.alarm_info.beAlertedMis + '-' + taskName;

      if (this.alarm_info.cc) {
        this.is_cc_role = this.alarm_info.cc.indexOf(this.login_user.mis_id) !== -1;
      }
      if (this.alarm_info.automaticDispositionId === 14) {
        this.file_out_show = true;
      }
      if (this.alarm_info.needPicture) {
        this.file_out_show = true;
      }

      // 设置反馈节点文案
      if (this.alarm_info.beAlertedMis === this.alarm_info.recipient) {
        this.self_appeal_text = this.$getText('operation_alarm_title_self_feedback', '本人反馈');
      } else if (this.alarm_info.supervisor === this.alarm_info.recipient || (this.alarm_info.noticeConfig && this.alarm_info.noticeConfig.noticeObject === 3)) {
        this.self_appeal_text = this.$getText('operation_alarm_title_supervisor_feedback', '直属主管反馈');
      } else {
        this.self_appeal_text = this.$getText('operation_alarm_title_cc_feedback', '抄送人反馈');
      }

      // 如果是接收人
      if (this.alarm_info.rowStatus === 2 && (this.alarm_info.recipient.indexOf(this.login_user.mis_id) !== -1 || isRdOrPm)) {
        this.appeal_show = true;
      }
      // 如果是接收人，展示编辑反馈按钮
      if ((this.alarm_info.recipient.indexOf(this.login_user.mis_id) !== -1) || isRdOrPm) {
        this.appeal_edit_show = true;
      }
      // 是领导，展示编辑反馈按钮
      if ((this.alarm_info.supervisor === this.login_user.mis_id) || isRdOrPm) {
        this.feedback_edit_show = true;
      }
      // 是领导，但用户尚未反馈
      if ((this.alarm_info.supervisor !== this.alarm_info.recipient
        && this.alarm_info.supervisor === this.login_user.mis_id && this.alarm_info.rowStatus === 2)) {
        this.appeal_result_show = true;
      }
      // 如果是领导，展示领导反馈
      if (((this.alarm_info.supervisor === this.login_user.mis_id || isRdOrPm) && this.alarm_info.supervisorFlag === 1 && this.alarm_info.rowStatus === 3)) {
        this.feedback_show = true;
      }
      // 如果反馈不为空，展示已反馈内容
      if (this.alarm_info.appealReason != null && this.alarm_info.appealReason !== '') {
        this.appeal_result_show = true;
        this.appeal_user = this.alarm_info.appealUser;
      } else {
        this.appeal_user = this.alarm_info.recipient;
      }
      // 如果领导反馈不为空，展示领导反馈内容
      if ((this.alarm_info.recipient.indexOf(this.login_user.mis_id) === -1 && this.alarm_info.feedbackReason != null && this.alarm_info.feedbackReason !== '')) {
        this.feedback_result_show = true;
      }
      // 报表
      if (this.alarm_info.riskDetails != null && this.alarm_info.riskDetails !== '') {
        try {
          this.risk_details_mapping = JSON.parse(this.alarm_info.riskDetails).dataMapping;
          this.risk_details = JSON.parse(this.alarm_info.riskDetails).data;
          let temp = this.risk_details;
          let start = (this.currentPage - 1) * this.limit;
          let end = this.limit;
          this.risk_details_show = temp.slice(start, end);
        } catch (e) {
          console.log(e);
        }
      }
      if (this.alarm_info.riskSummary != null && this.alarm_info.riskSummary !== '') {
        try {
          this.risk_summary_mapping = JSON.parse(this.alarm_info.riskSummary).dataMapping;
          this.risk_summary = JSON.parse(this.alarm_info.riskSummary).data;
          if (this.risk_summary.length > 10) {
            this.risk_height = '400px';
          }
        } catch (e) {
          console.log(e);
        }
      }
      if (this.alarm_info.feedbackList && this.alarm_info.feedbackList.length > 0) {
        this.radioList = [];
        this.superiorRadioList = [];

        const feedbackList = this.alarm_info.feedbackList;
        if (feedbackList && feedbackList.length > 0) {
          feedbackList.forEach(item => {
            if (item.type === 0) {
              if (this.$i18nClient.getCurrentLocale() === 'en') {
                this.radioList.push(item.enContent ?  item.enContent : item.content);
              } else {
                this.radioList.push(item.content);
              }
            }
            if (item.type === 1) {
              if (this.$i18nClient.getCurrentLocale() === 'en') {
                this.superiorRadioList.push(item.enContent ? item.enContent : item.content);
              } else {
                this.superiorRadioList.push(item.content);
              }
            }
          })
        }
      } else {
        if (this.alarm_info.noticeConfig.feedbackLabelList) {
          this.radioList = this.alarm_info.noticeConfig.feedbackLabelList.split(',');
        }
        if (this.alarm_info.noticeConfig.supervisorFeedbackLabelList) {
          this.superiorRadioList = this.alarm_info.noticeConfig.supervisorFeedbackLabelList.split(',');
        }
      }
      this.$nextTick(() => {
        this.checkContentOverflow();
      });
    },
    handlePictureCardPreview(file) {
      this.previewImageUrl = file.url;
      this.previewVisible = true;
    },
    uploadToVenus(response, file) {
      if (response.code === 0) {
        file.url = response.data;
        this.files.push(file);
      } else {
        this.$mtd.message.error("上传失败");
      }
    },
    picturePreview(item) {
      this.activeImg = item;
      this.resultPreviewModal = true;
    },
    removePicture(file) {
      this.files.splice(this.files.indexOf(file), 1);
    },
    async submit_file_out() {
      let pictureUrl = [], formData = {};
      for (let i = 0; i < this.files.length; i++) {
        pictureUrl.push(this.files[i].url);
      }
      formData.appealType = this.appeal_type;
      formData.appealReason = this.appeal_other_reason;
      formData.pictures = pictureUrl.join(",");
      formData.sendObject = this.sendObject;
      formData.id = this.alarm_id;
      formData.appealFeedbackType = '0';
      formData.needPrivacyFeedback = this.alarm_info.needPrivacyFeedback;
      if (this.alarm_info.feedbackList &&  this.alarm_info.feedbackList.length > 0) {
        this.alarm_info.feedbackList.forEach(item => {
          if (item.type === 0 && (item.content === this.appeal_type || item.enContent === this.appeal_type)) {
            formData.appealFeedbackType = item.feedbackType;
            formData.invokePrivacy = item.invokePrivacy;
          }
        })
      }
      await this.api_update_reminders_inquiries(formData).then(function () {
        window.location.reload();
      });
    },
    back_alarms() {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        this.$router.push('/alarm');
      }
    },
    async submit_appeal_reason() {
      let vm = this;
      if (this.appeal_type === 0) {
        vm.$mtd.message.error('请选择原因');
        return;
      }
      if (this.appeal_other_reason === '') {
        vm.$mtd.message.error('请填写反馈详情');
        return;
      }

      let params = {id: this.alarm_id, appealUser: this.login_user.mis_id};
      params['appealType'] = this.appeal_type;
      params['appealReason'] = this.appeal_other_reason;
      params['appealFeedbackType'] = '0';
      params['needPrivacyFeedback'] = this.alarm_info.needPrivacyFeedback;
      if (this.alarm_info.feedbackList &&  this.alarm_info.feedbackList.length > 0) {
        this.alarm_info.feedbackList.forEach(item => {
          if (item.type === 0 && (item.content === this.appeal_type || item.enContent === this.appeal_type)) {
            params['appealFeedbackType'] = item.feedbackType;
            params['invokePrivacy'] = item.invokePrivacy;
          }
        })
      }
      await this.api_update_reminders_inquiries(params).then(function () {
        window.location.reload();
      });
    },
    async submit_feedback_reason() {
      let vm = this;
      if (this.feedback_reason === '') {
        vm.$mtd.message.error('请确认信息');
        return;
      }
      if (this.feedback_other_reason === '') {
        vm.$mtd.message.error('请填写确认信息');
        return;
      }

      let params = {id: this.alarm_id};
      params['feedbackReason'] = this.feedback_reason + '：' + this.feedback_other_reason;
      params['supervisorFeedback'] = this.feedback_reason;
      params['supervisorFeedbackType'] = '0';
      if (this.alarm_info.feedbackList &&  this.alarm_info.feedbackList.length > 0) {
        this.alarm_info.feedbackList.forEach(item => {
          if (item.type === 1 && (item.content === this.feedback_reason || item.enContent === this.feedback_reason)) {
            params['supervisorFeedbackType'] = item.feedbackType;
          }
        })
      }
      await this.api_update_reminders_inquiries(params).then(function () {
        window.location.reload();
      });
    },
    export_to_excel() {
      // 风险概览的文件
      let workSheet = XLSX.utils.json_to_sheet(this.risk_summary, {header: this.risk_summary_mapping.keys});
      // 日志抽样的数据
      let workSheet2 = XLSX.utils.json_to_sheet(this.risk_details, {header: this.risk_details_mapping.keys});
      const wb = XLSX.utils.book_new();
      const range = XLSX.utils.decode_range(workSheet['!ref']);
      const range2 = XLSX.utils.decode_range(workSheet2['!ref']);
      // 修改表头1
      for (let c = range.s.c; c <= range.e.c; c++) {
        const header = XLSX.utils.encode_col(c) + '1';
        workSheet[header].v = this.risk_summary_mapping[workSheet[header].v];
      }
      // 修改表头2
      for (let c = range2.s.c; c <= range2.e.c; c++) {
        const header = XLSX.utils.encode_col(c) + '1';
        workSheet2[header].v = this.risk_details_mapping[workSheet2[header].v];
      }

      XLSX.utils.book_append_sheet(wb, workSheet, "风险详情");
      XLSX.utils.book_append_sheet(wb, workSheet2, "明细日志");
      /* generate file and send to client */
      XLSX.writeFile(wb, "日志数据.xlsx");
    },
    editAppeal() {
      this.appeal_result_show = false;
      this.editAppealFlag = true;
      this.appeal_show = true;
      // 图片同步
      if (this.alarm_info.pictures) {
        let strings = this.alarm_info.pictures.split(',');
        this.files = [];
        strings.forEach(picture => {
          this.files.push({url: picture});
        });
      }

      this.sendObject = this.alarm_info.sendObject;
      this.appeal_type = this.alarm_info.appealType;
      this.appeal_other_reason = this.alarm_info.appealReason;
    },
    editCancel() {
      this.appeal_show = false;
      this.appeal_result_show = true;
    },
    editFeedback() {
      this.feedback_result_show = false;
      this.editFeedbackFlag = true;
      this.feedback_show = true;
      let array = this.alarm_info.feedbackReason.split("：");

      this.feedback_reason = array[0];
      this.feedback_other_reason = array[1];
    },
    editFeedbackCancel() {
      this.feedback_show = false;
      this.feedback_result_show = true;
    },
    onCopy() {
      this.$mtd.message.success(this.$getText('operation_alarm_copy_success', '复制成功'));
    },
    onError() {
      this.$mtd.message.error("复制失败");
    },
    show_task_button() {
      let flag = false;
      this.role_list.forEach(item => {
        if (item === 'rd' || item === 'pm' || item === 'partner') {
          flag = true;
        }
      });
      return flag;
    },
    isRdOrPm() {
      let flag = false;
      this.role_list.forEach(item => {
        if (item === 'rd' || item === 'pm') {
          flag = true;
        }
      });
      return flag;
    },
    open_task_detail() {
      if (sso.isProd()) {
        window.open('https://tjt.sankuai.com/#/tasks/' + this.alarm_info.taskId + '?source=survey');
      } else {
        window.open('https://operation.sec.test.sankuai.com/#/tasks/' + this.alarm_info.taskId + '?source=survey');
      }
    },
    getDescription(appeal_type, type) {
      if (this.alarm_info.feedbackList && this.alarm_info.feedbackList.length > 0) {
        const targetFeedback = this.alarm_info.feedbackList.find(
          feedback => feedback.type === type && (feedback.content === appeal_type || feedback.enContent === appeal_type)
        );

        if (!targetFeedback) {
          return '';
        }

        const isEnglish = this.$i18nClient.getCurrentLocale() === 'en';
        return isEnglish ? (targetFeedback.enExtra || targetFeedback.extra || '') : (targetFeedback.extra || '');
      }
      return '';
    },
    query_misid_list(keyword) {
      const vm = this;
      clearTimeout(vm.remote_mis_timer);
      if (keyword) {
        vm.misid_loading = true;
        vm.remote_mis_timer = setTimeout(async () => {
          const response = await vm.api_query_org_misid_list({keyword});
          vm.user_misid_list = response.data;
          vm.misid_loading = false;
        }, 500);
      }
    },
    open_cc_modal() {
      this.cc_modal = true;
    },
    close_cc_modal() {
      this.cc_modal = false;
      this.cc_form = {
        ccList: []
      }
    },
    async submit_cc_form() {
      await new Promise((resolve, reject) => {
        this.$refs.cc_form_ref.validate((valid) => {
          if (valid) {
            const params = {
              idList: [this.alarm_id],
              ccList: this.cc_form.ccList
            };
            const vm = this;
            this.api_check_task_vp({misIdList: this.cc_form.ccList}).then(res => {
              if (res.code === 0 && res.data && res.data.length > 0) {
                this.$mtd.confirm({
                  title: this.$getText('operation_alarm_include_vp_title', '涉及高职级人群提醒'),
                  message: this.$getText('operation_alarm_include_vp_tips', {'params': res.data.join(',')}),
                  width: '430px',
                  showCancelButton: true,
                  cancelButtonText: this.$getText('operation_alarm_include_vp_btn_cancel', '取消操作'),
                  okButtonText: this.$getText('operation_alarm_include_vp_btn_confirm', '确认提交'),
                  onCancel: function () {
                    reject('rejected');
                  },
                  onOk: function () {
                    vm.api_add_reminders_cc(params).then(res => {
                      if (res.code === 0) {
                        vm.$mtd.message.success(vm.$getText('operation_alarm_cc_add_success_tips', '添加抄送人成功'));
                        vm.init_data();
                        vm.close_cc_modal();
                      } else {
                        vm.$mtd.message.success(vm.$getText('operation_alarm_cc_add_failure_tips', '添加抄送人失败'));
                      }
                      resolve();
                    }).catch(() => {
                      resolve();
                    });
                  }
                }).catch(() => {
                  resolve();
                })
              } else {
                vm.api_add_reminders_cc(params).then(res => {
                  if (res.code === 0) {
                    vm.$mtd.message.success(vm.$getText('operation_alarm_cc_add_success_tips', '添加抄送人成功'));
                    vm.init_data();
                    vm.close_cc_modal();
                  } else {
                    vm.$mtd.message.success(vm.$getText('operation_alarm_cc_add_failure_tips', '添加抄送人失败'));
                  }
                  resolve();
                }).catch(() => {
                  resolve();
                });
              }
            })
          } else {
            resolve();
          }
        });
      })
    },
    open_change_supervisor_modal() {
      this.change_supervisor_modal = true;
    },
    close_change_supervisor_modal() {
      this.change_supervisor_modal = false;
      this.change_supervisor_form = {
        supervisor: '',
        reason: ''
      }
    },
    async submit_change_supervisor_form() {
      await new Promise((resolve, reject) => {
        this.$refs.change_supervisor_form_ref.validate((valid) => {
          if (valid) {
            const params = {
              reminderId: this.alarm_id,
              supervisor: this.change_supervisor_form.supervisor,
              reason: this.change_supervisor_form.reason
            };

            const vm = this;
            this.api_check_task_vp({misIdList: [this.change_supervisor_form.supervisor]}).then(res => {
              if (res.code === 0 && res.data && res.data.length > 0) {
                this.$mtd.confirm({
                  title: '涉及高职级人群提醒',
                  message: '当前操作涉及高职级人群(L10及以上)【' + res.data.join(',') + '】，请谨慎操作。',
                  width: '430px',
                  showCancelButton: true,
                  cancelButtonText: '取消操作',
                  okButtonText: '确认提交',
                  onCancel: function () {
                    reject('rejected');
                  },
                  onOk: function () {
                    vm.api_change_supervisor(params).then(res => {
                      if (res.code === 0) {
                        vm.$mtd.message.success('变更确认人成功');
                        vm.init_data();
                        vm.close_change_supervisor_modal();
                      } else {
                        vm.$mtd.message.success('变更确认人失败');
                      }
                      resolve();
                    }).catch(() => {
                      resolve();
                    });
                  }
                }).catch(() => {
                  resolve();
                })
              } else {
                vm.api_change_supervisor(params).then(res => {
                  if (res.code === 0) {
                    vm.$mtd.message.success('变更确认人成功');
                    vm.init_data();
                    vm.close_change_supervisor_modal();
                  } else {
                    vm.$mtd.message.success('变更确认人失败');
                  }
                  resolve();
                }).catch(() => {
                  resolve();
                });
              }
            })
          } else {
            resolve();
          }
        });
      })
    }
  },
}
</script>

<style scoped>

.page-head-title {
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 20px;
  color: #333333;
  letter-spacing: 0.5px;
  line-height: 28px;
}

.page-head-title-tag {
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 6px;
  margin-left: 8px;
}

.page-second-title {
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.87);
  letter-spacing: 0;
  line-height: 22px;
}

.padding-left-40 {
  padding-left: 40px;
}

.info-row {
  line-height: 36px;
  /*font-family: PingFangSC-Medium, sans-serif;*/
  font-size: 14px;
  letter-spacing: 0;
  padding: 0 12px;
  font-weight: normal;
}

.info-row .info-title {
  color: rgba(0, 0, 0, 0.60);
  width: 100px;
  float: left;
  text-align: right;
  margin-right: 20px;
}

.info-row .info-content {
  color: rgba(0, 0, 0, 0.84);
  margin-left: 100px;
  margin-right: 20px;
  white-space: nowrap;
  text-overflow:ellipsis;
  overflow:hidden;
}

.info-row .info-full-content {
  margin-left: 120px;
  margin-top: 8px;
  line-height: 20px;
  word-break: break-all;
}

.info-col {
  height: 36px;
}

.full-block-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.full-block-table .table-row {
  height: 36px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.none-height-table > .table-row {
  height: auto !important;
}

.full-block-table .table-row td {
  line-height: 36px;
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.60);
  letter-spacing: 0;
  padding: 0 12px;
  border-right: 1px solid rgba(0, 0, 0, 0.06);
  overflow: hidden;
  /*white-space: nowrap;*/
  /*text-overflow: ellipsis;*/
}

.full-block-table .table-row td.td-title {
  background: #F7F7F7;
  width: 130px;
}

.feedback-reason-block {
  background: #F7F7F7;
  border: 1px solid rgba(0, 0, 0, 0.07);
  padding: 15px;
  padding-bottom: 0;
}

.info-row .alarm_info_content {
  white-space: normal;
  line-height: 20px;
}

.submit-helper {
  font-size: 12px;
  line-height: 20px;
  color: rgba(0, 0, 0, .36);
  margin-left: 4px;
}

.mtd-steps-custom >>> .mtd-step {
  display: flex;
  align-items: baseline;
}

.mtd-steps-custom >>> .mtd-step-main {
  width: calc(100% - 20px);
  position: static;
  margin-left: 4px;
}

.mtd-steps-custom >>> .mtd-step-head {
  position: static;
}

.mtd-steps-custom >>> .mtd-step-main-title {
  padding-left: 10px;
  color: rgba(0,0,0,.84);
}

.mtd-steps-custom >>> .mtd-step-head-line {
  display: block !important;
}

.mtd-steps-custom >>> .mtd-step-head-line {
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  height: calc(100% - 18px);
}
.mtd-steps-custom >>> div:last-child .mtd-step-head-line {
  display: none !important;
}
.mtd-steps-custom >>> .mtd-step-main-description {
  padding: 10px 4px 20px 10px;
  word-break: break-all;
}
.step-time-text {
  float: right;
  color: grey;
  font-size: 12px;
}

.step-processing-text {
  color: #0a70f5;
  padding-right: 5px
}

.mtd-tag-small {
  max-width: none;
}
</style>
